'use strict';

export function rectangleAroundLine( pointA, pointB, width ) {

  const main = rectangleOnLine( pointA, pointB, width );
  if ( false === main ) {
    return false;
  }
  const top_r = rectangleOnLine( main[ 0 ], main[ 1 ], width );
  const bottom_r = rectangleOnLine( main[ 2 ], main[ 3 ], width );

  return [
    top_r[ 1 ],
    top_r[ 2 ],
    bottom_r[ 1 ],
    bottom_r[ 2 ],
  ];

}
export function rectangleOnLine( pointA, pointB, width ) {

  const vector_x = pointB[ 0 ] - pointA[ 0 ];
  const vector_y = pointB[ 1 ] - pointA[ 1 ];

  const perpendicular_x = vector_y;
  const perpendicular_y = -vector_x;
  const length = Math.sqrt( perpendicular_x * perpendicular_x + perpendicular_y * perpendicular_y );

  if ( 0 !== length ) {

    const normalized_x = perpendicular_x / length;
    const normalized_y = perpendicular_y / length;

    return [
      [ pointA[ 0 ] + normalized_x * width / 2, pointA[ 1 ] + normalized_y * width / 2 ],
      [ pointA[ 0 ] - normalized_x * width / 2, pointA[ 1 ] - normalized_y * width / 2 ],
      [ pointB[ 0 ] - normalized_x * width / 2, pointB[ 1 ] - normalized_y * width / 2 ],
      [ pointB[ 0 ] + normalized_x * width / 2, pointB[ 1 ] + normalized_y * width / 2 ],
    ];

  }

  return false;

}
